import { FC } from "react";

type Props = {
	videoId?: string;
	playlistId?: string;
	width?: string | number;
	height?: string | number;
	title?: string;
};

const YouTubeEmbed: FC<Props> = ({ videoId, playlistId, width, height, title }) => {
	const src = videoId ? `https://www.youtube.com/embed/${videoId}` : playlistId ? `https://www.youtube.com/embed/videoseries?list=${playlistId}` : '';

	return (
		<iframe
			width={width}
			height={height}
			src={src}
			title={title || 'YouTube video player'}
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			allowFullScreen
			style={{ border: 'none' }}
		/>
	);
};

export default YouTubeEmbed;
